import React from 'react';
import { useIntl } from 'react-intl';

import { importComponent } from '@xingternal/hops';

import { useBreakpoints } from '@/hooks';

type Props = {
  isShown: boolean;
  handleCloseClick: () => void;
};

const StyledBottomSheet = importComponent(
  () => import('./search-alert-modal.styles'),
  ({ BottomSheet: StyledBottomSheet }) => StyledBottomSheet
);

const StyledPopUpWindow = importComponent(
  () => import('./search-alert-modal.styles'),
  ({ PopUpWindow: StyledPopUpWindow }) => StyledPopUpWindow
);

export const SearchAlertModalWrapper: React.FC<Props> = ({ children, isShown, handleCloseClick }) => {
  const { isMobile } = useBreakpoints();
  const { formatMessage } = useIntl();

  return isMobile ? (
    <StyledBottomSheet
      show={isShown}
      onOutsideClick={handleCloseClick}
      keepBottomSheetInDom={false}
      aria-labelledby={null}
      aria-label={formatMessage({ id: 'JOBS_POSTING_CREATE_ALERT_LIGHTBOX_HEADER' })}
      data-cy="create-alert-dialog"
    >
      {children}
    </StyledBottomSheet>
  ) : (
    <StyledPopUpWindow
      isShown={isShown}
      hide={handleCloseClick}
      onDimmerClick={handleCloseClick}
      noPadding
      keepDialogInDom={false}
      aria-labelledby={null}
      aria-label={formatMessage({ id: 'JOBS_POSTING_CREATE_ALERT_LIGHTBOX_HEADER' })}
      data-cy="create-alert-dialog"
    >
      {children}
    </StyledPopUpWindow>
  );
};
